// Romantic letter message for the intro screen

export const LETTER_MESSAGE = `Hi {partner},

I wanted to do something special for you this Valentine's Day. You make every day brighter, and I'm so grateful to have you in my life.

I built this little world just for us—a place where we can make new memories together.

I love you so much.

Will you be my Valentine? 🌹`;

export const NO_RESPONSE_MESSAGE = `That's completely okay! 💕

Thank you for being honest with me. Whatever your reason, I respect it fully.

I hope this brought a little smile to your face anyway. You deserve all the happiness in the world.

Take care of yourself always. 🌸`;

export const SHARE_MESSAGE = `Hey! Check out the Valentine's plan I just built! 💕`;
